// Messages (es)

const config = {
  code: 'es',
  label: 'Español',
  label_en: 'Spanish',
  rtl: false,
};

const messages = {
  // Navbar
  navbar_title: 'Cancelar Suscripción',

  // Unsubscribe page
  unsubpage_title: '¿Querés cancelar tu suscripción?',
  unsubpage_msg1:
    'Si ya no deseas recibir comunicaciones de marketing de nuestra parte, por favor haz clic en el botón de cancelar suscripción para confirmar.',
  unsubpage_unsubscribe: 'Cancelar Suscripción',
  unsubpage_unsubscribing: 'Cancelando Suscripción...',
  unsubpage_result_success: 'Ya cancelaste tu suscripción.',
  unsubpage_result_error: 'Error al cancelar la suscripción.',

  // Error page
  errorpage_title: '¡Ups!',
  errorpage_msg1: 'Parece que este enlace ya venció o no es válido.',
  errorpage_msg2: 'No pudimos completar tu solicitud.',
};

const lang = { config, messages };

export default lang;
